
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member-dispute",
      function () {
        return require("private-next-pages/member-dispute/index.tsx");
      }
    ]);
  